import {UserOutlined} from '@ant-design/icons';
import {BackendUserManager} from 'components/Backend/User/Manager';

export const title = '使用者管理';
export const orderNum = 0;

export const icon = <UserOutlined />;
export default BackendUserManager;
